import React, { useState, useEffect } from 'react';
import Footer from '../../agent/Tabs/Payments/Footer';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import StepBullets from '../StepBullets';
import { IconButton } from '@material-ui/core';
import iconClient from '../images/iconClient.png';
import { useHistory } from 'react-router-dom';
import FlechaIzquierda from './arrowLeft.svg';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getClientsRFC, persistDataPolicy } from '../../../redux/actions/clientActions';
import ModalUserNotFound from '../ModalUserNotFound';
import ModalRFCNotFound from '../ModalRFCNotFound';
import ModalNoPendingReceipts from '../ModalNoPendingReceipts';
import gifTooltip from '../images/gifTooltip.gif';
import { Tooltip } from '@material-ui/core';
import FooterMobile from '../../agent/Tabs/Payments/FooterMobile';
import { isMobile } from 'react-device-detect';
import Spinner from '../Spinner';
const CustomTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: '#fff',
    color: '#000',
    fontSize: '14px',
    border: '1px solid #ddd',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '5px',
    padding: '10px',
    maxWidth: '200px'
  },
  arrow: {
    color: '#ddd'
  }
}))(Tooltip);

const ValidationUser = ({ getClientsRFC, persistDataPolicy, policyData, clientToken }) => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [openRFC, setOpenRFC] = useState(false);
  const [openNoPendingReceipts, setOpenNoPendingReceipts] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    rfc: policyData && policyData.rfc ? policyData.rfc : ''
  });

  const [errors, setErrors] = useState({
    rfc: ''
  });
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    if (policyData && policyData.rfc) {
      const rfcError = !/^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/i.test(policyData.rfc)
        ? 'El RFC debe tener el formato correcto (Ej. ABC123456T1Z)'
        : '';
      setErrors({ rfc: rfcError });
      setIsButtonDisabled(rfcError !== '');
      setFormData({ rfc: policyData.rfc });
    }
  }, [policyData]);
  const handleChange = e => {
    const { name, value } = e.target;

    if (name === 'rfc' && value.length > 13) {
      return;
    }

    setFormData({ ...formData, [name]: value });

    let rfcError = '';

    if (value === '') {
      rfcError = 'Campo Requerido';
    } else if (!/^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/i.test(value)) {
      rfcError = 'El RFC debe tener el formato correcto (Ej. ABC123456T1Z)';
    }

    setErrors({ ...errors, [name]: rfcError });

    setIsButtonDisabled(rfcError !== '' || value === '');
  };

  const handleSearch = async () => {
    setLoading(true);
    const json = {
      rfc: formData.rfc,
      poliza: policyData.poliza,
      oficina: policyData.oficina,
      ramo: policyData.ramo
    };
    const sanitizedData = {
      oficina: policyData.oficina ? parseInt(policyData.oficina, 10).toString() : '',
      ramo: policyData.ramo ? parseInt(policyData.ramo, 10).toString() : '',
      poliza: policyData.poliza ? parseInt(policyData.poliza, 10).toString() : '',
      rfc: formData.rfc
    };
    try {
      await getClientsRFC(clientToken, sanitizedData);
      history.push('/cobranza/recibos');
      persistDataPolicy(json);
    } catch (error) {
      if (error.response && error.response.data) {
        if (error.response.data.error === 'RFC is not correct') {
          setOpenRFC(true);
        } else if (error.response.data.error === 'No pending receipts found') {
          setOpenNoPendingReceipts(true);
        } else {
          setOpen(true);
        }
      } else {
        setOpen(true);
      }
    } finally {
      setLoading(false);
    }
  };
  const handleExpandClick = () => {
    history.push(`/cobranza/cliente`);
  };
  const resetForm = () => {
    setFormData({
      rfc: ''
    });
    setOpen(false);
    setOpenRFC(false);
    setOpenNoPendingReceipts(false);
    setIsButtonDisabled(true);
  };
  return (
    <React.Fragment>
      <div
        style={{
          display: 'flex',
          width: '100vw',
          maxWidth: '1440px',
          margin: '0 auto',
          padding: isMobile ? '100px 6%' : '60px 150px 100px 100px',
          flexDirection: isMobile ? 'column' : 'row'
        }}
      >
        <div 
          style={{
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            paddingRight: isMobile ? '0' : '40px',
            paddingBottom: isMobile ? '20px' : '0'
          }}
        >
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
              paddingBottom: isMobile ? '20px' : '0'
            }}
          >
            <div
              style={{
                width: '105px',
                display: 'flex',
                justifyContent: 'flex-start',
                gap: '5px',
                alignItems: 'center'
              }}
            >
              <IconButton onClick={() => handleExpandClick()} style={{ paddingRight: 0 }}>
                <img src={FlechaIzquierda} />
              </IconButton>
              <span
                style={{
                  color: '#2D6DF6',
                  fontSize: '16px',
                  fontWeight: '500',
                  fontFamily: 'Sura Sans',
                  cursor: 'pointer'
                }}
                onClick={() => handleExpandClick()}
              >
                Atrás
              </span>
            </div>
            <StepBullets 
              currentStep={2}
              style={{
                position: isMobile ? 'absolute' : 'relative',
                left: isMobile ? '50%' : 'auto',
                transform: isMobile ? 'translateX(-50%)' : 'none',
                height: isMobile ? '40px' : 'auto'
              }}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '83px',
                height: '40px',
                background: isButtonDisabled ? '#ccc' : '#E3E828',
                borderRadius: '28px',
                cursor: isButtonDisabled ? 'not-allowed' : 'pointer'
              }}
              onClick={!isButtonDisabled ? handleSearch : undefined}
            >
              {loading ? <Spinner /> : 'Continuar'}
            </div>
          </div>
          <span style={{ fontSize: '26px' }}>2. Validación de usuario</span>
          <CustomTooltip
            title={
              <div>
                <img src={gifTooltip} alt="Descripción del GIF" style={{ width: '150px', height: 'auto' }} />
              </div>
            }
            placement="right"
            arrow
          >
            <span style={{ fontSize: '16px', color: '#888B8D', marginTop: '1rem' }}>
              Por tu seguridad es necesario confirmar los siguientes datos
            </span>
          </CustomTooltip>

          <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', marginTop: '20px' }}>
            <FormControl error={!!errors.rfc} style={{ width: isMobile ? '100%' : '48%', marginRight: '10px' }}>
              <span style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#2D6DF6' }}>
                RFC <span style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#D12D35' }}>*</span>
              </span>
              <Input
                id="rfc"
                name="rfc"
                value={formData.rfc}
                onChange={handleChange}
                aria-describedby="oficina-error-text"
              />
              {errors.rfc && (
                <FormHelperText id="oficina-error-text" error>
                  {errors.rfc}
                </FormHelperText>
              )}
            </FormControl>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: isMobile ? '100%' : '264px',
            height: isMobile ? '100%' : '464px',
            padding: isMobile ? '10px 6% 24px' : '21px',
            background: '#FFFFFF',
            borderRadius: '20px',
            boxShadow: '0px 3px 6px #00000029',
            marginTop: isMobile ? '20px' : '0',
            alignItems: isMobile ? 'center' : 'flex-start'
          }}
        >
          <img
            src={iconClient}
            alt="Icono de cliente"
            style={{ width: '100px', height: '100px', alignSelf: 'center' }}
          />
          <span
            style={{
              fontSize: '26px',
              fontWeight: 500,
              color: '#2D6DF6',
              lineHeight: '22px',
              fontFamily: 'Sura Sans',
              textAlign: isMobile? 'center' : 'left'
            }}
          >
            ¿No conoces el número de tu póliza?
          </span>
          <span style={{ fontSize: '12px', color: '#000000', marginTop: '20px', fontFamily: 'Sura Sans' }}>
            Haz click aquí y podrás realizar la búsqueda por:
          </span>
          <span style={{ fontSize: '16px', color: '#000000', marginTop: '20px', fontFamily: 'Sura Sans' }}>-RFC</span>
          <span style={{ fontSize: '16px', color: '#000000', fontFamily: 'Sura Sans' }}>-NOMBRE COMPLETO</span>
          <span style={{ fontSize: '16px', color: '#000000', fontFamily: 'Sura Sans' }}>-TIPO DE PÓLIZA</span>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '16px',
              fontWeight: '500',
              width: '103px',
              height: '40px',
              borderRadius: '28px',
              border: '1px solid #0133A0',
              color: '#0133A0',
              alignSelf: 'center',
              marginTop: '30px',
              cursor: 'pointer'
            }}
            onClick={() => history.push('/cobranza/identificate')}
          >
            Buscar
          </div>
        </div>
        {open && <ModalUserNotFound setOpen={setOpen} open={open} resetForm={resetForm} />}
        {openRFC && <ModalRFCNotFound setOpen={setOpenRFC} open={openRFC} />}
        {openNoPendingReceipts && <ModalNoPendingReceipts setOpen={setOpenNoPendingReceipts} open={openNoPendingReceipts} />}
      </div>
      {isMobile && <FooterMobile />}
      {!isMobile && <Footer />}
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  clientToken: state.clientReducer.clientToken,
  policyData: state.clientReducer.policyData
});

const mapDispatchToProps = {
  getClientsRFC,
  persistDataPolicy
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidationUser);



// WEBPACK FOOTER //
// ./src/containers/client/validation/index.js